"use client"; // Error components must be Client Components

import { postLogAction } from "@/actions/loger-action";
import AppButton from "@/common/AppButton";
import { ArrowRightIcon } from "@/icons";
import { Box } from "@mui/material";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const pathname = usePathname(); // Lấy đường dẫn hiện tại
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
    // if (!EnvConstant.IS_DEV)
    // postLogAction({
    //   host: window.location.host,
    //   message: error.message + " tại pathName " + pathname,
    //   fullMessage: error.stack || error.message,
    // });
  }, [error]);

  return (
    <Box className="content-main min-h-app items-center flex bg-light">
      <Box className="text-center max-h-full overflow-y-auto w-full p-10">
        <section className="message-404">
          <h1 className="h1 mb-4 text-dark">
            Đã có lỗi xảy ra
            <br />
            <span className="text-error">{error.message}</span>
          </h1>
          <Box className="flex items-center justify-center gap-2">
            <Link className="btn-qi btn-qi-primary btn-qi-xl" href="/admin">
              <AppButton variant="contained" color="primary" component={"span"}>
                Quay lại trang chủ <ArrowRightIcon />
              </AppButton>
            </Link>
            <AppButton variant="contained" color="primary" onClick={reset}>
              Tải lại
            </AppButton>
          </Box>
        </section>
      </Box>
    </Box>
  );
}
